import { MotionPlugin } from '@vueuse/motion';
import type { App } from 'vue';

export function vueMotion(app: App) {
  app.use(MotionPlugin);
}
